const prizeWheel = {
  getList: 'PrizeWheel/getlist',
  add: 'PrizeWheel/add',
  edit: 'PrizeWheel/update',
  get: 'PrizeWheel/get',
  getAll: 'PrizeWheel/getall',
  prizeWheelUsers: 'UserPrize/getlist'
}

export default prizeWheel